"use client";

import { useAuthLeftContent } from "~/app/auth/_context/AuthLeftContentContext";
import { Section } from "~/components/layout/Section";
import { Paragraph, Title } from "~/components/ui/Typography";

export function AuthLeftPanel() {
  const { leftContent } = useAuthLeftContent();
  const { leftTitle, leftDescription, leftStats = [] } = leftContent;

  return (
    <Section
      className="py-0"
      containerClassName="relative z-[1] max-w-[420px]"
      backgroundClassName="bg-transparent px-12 pt-28 pb-14"
    >
      <Title
        as="h2"
        size="section"
        className="mb-4 text-[#E8F4FF] [&_em]:text-[#90D5FF]"
      >
        {leftTitle}
      </Title>

      <Paragraph className="mb-8 text-[#90A8C0]">{leftDescription}</Paragraph>

      {leftStats.length > 0 ? (
        <div className="mt-4 flex gap-8">
          {leftStats.map((stat) => (
            <div key={stat.label} className="text-center">
              <Title
                as="h3"
                size="section"
                className="text-[28px] leading-none text-[#E8F4FF]"
              >
                {stat.value}
                {stat.accent ? (
                  <span className="text-[#90D5FF]">{stat.accent}</span>
                ) : null}
              </Title>
              <div className="mt-1 text-[10px] font-semibold uppercase tracking-[0.05em] text-[#7090A8]">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      ) : null}
    </Section>
  );
}
